interface IPinIcon {
  pinColor: string;
  pinIcon: string;
  pinId?: string;
}

const PinIcon = ({ pinColor, pinIcon, pinId }: IPinIcon) => {
  const color = pinColor || "#6B46C9";

  return (
    <span className="icon-style" key={pinId}>
      <span
        className="marker-pin marker-icon-marker"
        style={{ color: color, fontSize: 34 }}
      >
        <span
          className={`marker-icon marker-icon-${pinIcon || "circle"}`}
          style={{
            color: color,
            fontSize: 16,
            top: 6
          }}
        ></span>
      </span>
    </span>
  );
};

export default PinIcon;
